module.exports = __webpack_public_path__ + "img/chosen.c1dc24.svg";